import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const getAllLeadsCountForBusiness = async (bid) => {
  try {
    const LeadsCollection = collection(db, "leads");

    let q = query(
      LeadsCollection,

      where("bid", "==", bid),
      where("is_deleted", "==", false)
    );

    const LeadsSnapshot = await getDocs(q);

    const count = LeadsSnapshot.size;

    return count;
  } catch (error) {
    console.log(error);
    return 0;
  }
};

export default getAllLeadsCountForBusiness;
